import React from "react";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Images from "../../utils/Images";

const Footer = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 text-white bg-red-600">
      <div className="px-4 mx-auto max-w-8xl sm:px-6 lg:px-8">
        <div className="flex flex-col items-center">
          {/* Logo and Tagline */}
          <div className="mb-8 text-center">
            <div className="flex justify-center items-center mb-8">
              <img
                src={Images.logo_white}
                alt="TXTConnect Logo"
                className="w-32"
              />
            </div>
            <p className="text-lg text-center">
              Personalized communication to the audience you value
            </p>
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-wrap gap-y-4 gap-x-8 justify-center mb-10">
            <Link to="/" className="hover:underline">
              Home
            </Link>
            <Link to="/products" className="hover:underline">
              Products
            </Link>
            <Link to="/contact-us" className="hover:underline">
              Contact Us
            </Link>
            {(location.pathname === "/" || location.pathname === "/home") && (
              <Link to="/#pricing" className="hover:underline">
                Pricing
              </Link>
            )}
          </nav>

          {/* Social Media Links */}
          <div className="flex mb-10 space-x-6">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/80"
            >
              <Facebook size={24} />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/80"
            >
              <Twitter size={24} />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/80"
            >
              <Linkedin size={24} />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/80"
            >
              <Instagram size={24} />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center">
            <p>© Copyright {currentYear}, TXTConnect All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
